import React from "react";
import ShopProductForm from "./ShopProductForm";

const ShopAddProduct = (props) => {
  const subMenuId = props.match && props.match.params.shopMenuId;
  return <ShopProductForm subMenuId={subMenuId} />;
};

export default ShopAddProduct;
